import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <div className="flex">
            <div className="loader">Loading...</div>
        </div>
    );
};

export default Loader;
